// React
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

// Components
import LegalAddr from "./LegalAddr";
import MailingAddr from "./MailingAddr";

// Services
import {
  fetchDistricts,
  fetchSubDistricts,
  fetchProvinces,
} from "./fetchGeoData"

interface ErrorType {
  prefixOther?: { message?: string }
  firstName?: { message?: string }
  lastName?: { message?: string }
  gender?: { message?: string }
  weight?: { message?: string }
  height?: { message?: string }
  dateOfBirth?: { message?: string }
  idCardNumber?: { message?: string }
  phoneNumber?: { message?: string }
}

interface IDistrict {
  id: number
  name_th: string
  name_en: string
  province_id: number
  created_at: string
  updated_at: string
  deleted_at: null
}

interface ISubDistrict {
  id: number
  zip_code: number
  name_th: string
  name_en: string
  amphure_id: number
}

type AddressInfoProps = {
  legalErrors: ErrorType
  mailingErros: ErrorType
}

const AddressInfo: React.FC<AddressInfoProps> = ({
  legalErrors,
  mailingErros,
}) => {
  const navigate = useNavigate()

  const [districts, setDistricts] = useState<IDistrict[]>([])
  const [subDistricts, setSubDistricts] = useState<ISubDistrict[]>([])
  const [provinceJSON, setProvinceJSON] = useState<any[]>([])

  useEffect(() => {
    const fetchDistrictsData = async () => {
      try {
        const districtsData = await fetchDistricts()
        setDistricts(districtsData)
      } catch (error) {
        navigate("/servererror", { replace: true })
      }
    }

    const fetchSubDistrictsData = async () => {
      try {
        const subDistrictsData = await fetchSubDistricts()
        setSubDistricts(subDistrictsData)
      } catch (error) {
        navigate("/servererror", { replace: true })
      }
    }

    const fetchProvincesData = async () => {
      try {
        const provincesData = await fetchProvinces()
        setProvinceJSON(provincesData)
      } catch (error) {
        navigate("/servererror", { replace: true })
      }
    }

    fetchProvincesData()
    fetchDistrictsData()
    fetchSubDistrictsData()
  }, [navigate])

  return (
    <div>
      <LegalAddr
        errors={legalErrors}
        provinces={provinceJSON}
        districts={districts}
        subDistricts={subDistricts}
      />
      <MailingAddr
        errors={mailingErros}
        provinces={provinceJSON}
        districts={districts}
        subDistricts={subDistricts}
      />
    </div>
  )
}

export default AddressInfo;
